export const formatMoney = (value?: number | null): string => {
  if (value === null || value === undefined) {
    return "-";
  }

  return value.toLocaleString("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
